var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('navbar'),_c('it-solutions'),_c('Competition'),_c('digital-change-over'),_c('WeAreHere'),_c('service-packages'),_c('packages'),_c('farmers'),_c('contact'),_c('Footer'),_c('backtotop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }